import { RcClasses } from '../../../foundation';
export var RcSnackbarClasses = RcClasses([], 'RcSnackbar');
